import common from "./common.json";

export const it = {
  common,
};
